import Vue from 'vue'
import inView from 'in-view'
import $ from 'jquery'
import {throttle} from 'lodash'
// import App from './App.vue'
// import Counter from './homepage/Counter.vue'

// Vue.component('counter', Counter)

import HomepageGallery from './homepage/Gallery.vue'
import ContactForm from './components/ContactForm.vue'
Vue.component('homepage-gallery', HomepageGallery)
Vue.component('contact-form', ContactForm)


new Vue({
  el: '#app'
  // render: h => h(App)
})




var menuClikckCounter = 0
function hamburgerClick(){
  if(menuClikckCounter % 2 == 0){
    $('header').attr('class', 'active')
    $("#hamburger").attr('class', 'active')
  } else {
    $('header').attr('class', 'inactive')
    $("#hamburger").attr('class', 'inactive')
  }
  menuClikckCounter++
  console.log(menuClikckCounter)
}

$("#hamburger").click(function(){
    hamburgerClick()
})

// $(".apply-now-drivers select").eq(0).height($(".address_city input").eq(0).height())
// console.log($(".apply-now-drivers select").eq(0).height())
// console.log($(".address_city input").eq(0).height())



//display submenus
// $( "header li.menu-item" ).hover(function() {  // mouse enter
//     if(window.innerWidth<992) return
//     $( this ).find( " > .sub-menu" ).show().addClass('active'); // display immediate child
//
// }, function(){ // mouse leave
//   if(window.innerWidth<992) return
//     if ( !$(this).hasClass("current_page_item") ) {  // check if current page
//         $( this ).find( ".sub-menu" ).hide(); // hide if not current page
//     }
//     $( this ).find( " > .sub-menu" ).removeClass('active'); // display immediate child
// });




// =========in view============

inView.offset(120);

inView('.tadaElement')
    .on('enter', el => {
        el.classList.add("tada");
    })

inView('.pulseElement')
    .on('enter', el => {
        el.classList.add("pulse");
    })

inView('.fadeInElement')
    .on('enter', el => {
        el.classList.add("fadeInUp");
        if(el.classList.contains('opacity0')) el.classList.remove("opacity0");
        if(el.classList.contains('opacity0-md')) el.classList.remove("opacity0-md");
        el.classList.add("opacity1");
    })

inView('.fadeInLeftElement')
    .on('enter', el => {
        el.classList.add("fadeInLeft");
        if(el.classList.contains('opacity0')) el.classList.remove("opacity0");
        if(el.classList.contains('opacity0-md')) el.classList.remove("opacity0-md");
        el.classList.add("opacity1");
    })
inView('.fadeInRightElement')
    .on('enter', el => {
        el.classList.add("fadeInRight");
        if(el.classList.contains('opacity0')) el.classList.remove("opacity0");
        if(el.classList.contains('opacity0-md')) el.classList.remove("opacity0-md");
        el.classList.add("opacity1");
    })

    inView('.fadeInUpElement')
    .on('enter', el => {
      el.classList.add("fadeInUp");
    })





          var spans = {
            homepage : [
              $("#section-0").offset().top + $("#section-0").innerHeight(),
              $("#section-1").offset().top + $("#section-1").innerHeight(),
              $("#section-2").offset().top + $("#section-2").innerHeight(),
              $("#section-3").offset().top + $("#section-3").innerHeight(),
              $("#section-4").offset().top + $("#section-4").innerHeight(),
              $("#contact-form").offset().top + $("#contact-form").innerHeight(),
              $("footer").offset().top + $("footer").innerHeight()
            ]
          }


          var headerSchemes = {
            homepage : [
              'blue', 'blue', 'white', 'blue', 'blue', 'blue', 'blue'
            ]
          }

          var arrowRotations  = [
            'bottom', 'bottom', 'bottom', 'bottom', 'bottom', 'left', 'top'
          ]



          var headerIndexOfPreviousPosition = 0;
          const checkPositionAndSetHeader =   throttle(function(e) {
            if(window.innerWidth < 992) return

            let headerDistanceFromTopOfElement = $("#header").offset().top + $("#header").innerHeight()

            if($("#homepage")){
              for(let i in spans.homepage){
                if(headerDistanceFromTopOfElement <= spans.homepage[i]){
                  document.querySelector('header').setAttribute('data-scheme', headerSchemes.homepage[i]);
                  headerIndexOfPreviousPosition = i
                  return;
                  }
                }
              }
            }, 300)




          var arrowsIndexOfPreviousPosition = 0;
          var rotationDirectionHolder = null;
          const checkPositionAndSetАrrows =   throttle(function(e) {
            if(!$("#homepage")) return;
            let arrowsDistanceFromTopOfElement = $("#arrows").offset().top + $("#arrows").innerHeight()
              for(let i in spans.homepage){
                if(arrowsDistanceFromTopOfElement <= spans.homepage[i]){
                document.querySelector('#arrows').setAttribute('data-scheme', headerSchemes.homepage[i]);
                 let rotationDirection = arrowRotations[i];
                 if(rotationDirection == rotationDirectionHolder){
                   console.log('fooo')
                   return
                 }
                 if(rotationDirectionHolder == 'top' && rotationDirection == 'left') rotationDirection = 'topToLeft'
                document.querySelector('#arrows').setAttribute('data-rotate', rotationDirection);
                arrowsIndexOfPreviousPosition = i
                rotationDirectionHolder = rotationDirection !== 'topToLeft'? rotationDirection : 'left'
                return;
                }
              }
            }, 300)


          var arrowIntervalActive = setInterval(setArrowsInterval, 3000)
          function setArrowsInterval(){
            $('#arrows .shp0').addClass('animated pulseBig')
            setTimeout(()=>{$('#arrows .shp0').removeClass('animated pulseBig')}, 1000)
          }



          window.addEventListener('scroll', checkPositionAndSetHeader);
          window.addEventListener('scroll', checkPositionAndSetАrrows);



import 'lightbox2/dist/css/lightbox.min.css';
import 'lightbox2/dist/js/lightbox.min.js';

lightbox.option({
  'resizeDuration': 200,
  'wrapAround': true
})


// WEBPACK FOOTER //
// ./src/main.js